import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  loginContainer: {
    paddingTop: theme.spacing(5),
  },
  loginPassword: {
    fontSize: '13px',
    letterSpacing: 0,
    color: '#03014C',
  },
  link: {
    color: '#3F7AEC',
    textDecoration: 'none',
  },
}));
